import React, { useEffect, useState } from "react";
import styled from "styled-components";

import { ClientsFilter, ClientsTable } from "../components/clients";
import { Box } from "@material-ui/core";
import { SelectInput } from "vqp-common";
import withAuthHeader from "../utils/withAuthHeader";
import { mapFetchClientsListResponse } from "../redux/mappers/clients";
import { api } from "../redux/store";
import qs from "querystring";

const PAGE_SIZE_OPTIONS = [
  { value: 10, name: "10 itens por página" },
  { value: 20, name: "20 itens por página" },
];

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const SelectWrapper = styled.div`
  min-width: 180px;
`;

const ClientFooter = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 15px 30px 15px;
  gap: 16px;
`;

const FooterText = styled.span`
  font-size: 14px;
  color: ${(props) => props.theme.colors.textBold};
`;

const PaginationButton = styled.button`
  padding: 8px 16px;
  font-size: 14px;
  color: ${(props) => props.theme.colors.primary};
  background: transparent;
  border: 1px solid ${(props) => props.theme.colors.primary};
  border-radius: 4px;
  cursor: pointer;
  margin: 0 8px;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  &:not(:disabled):hover {
    background: ${(props) => props.theme.colors.primary};
    color: white;
  }
`;

const PaginationInfo = styled.span`
  font-size: 14px;
  color: ${(props) => props.theme.colors.textPrimary};
`;

const ClientsPage = () => {
  const [filters, setFilters] = useState(undefined);
  const [clients, setClients] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  const handleFilter = (search) => {
    setFilters(search);
    setCurrentPage(1);
  };

  const handlePageSizeChange = (selectedIndex) => {
    const value = PAGE_SIZE_OPTIONS[selectedIndex]?.value ?? 20;
    setPageSize(value);
    setCurrentPage(1);
  };

  const list = clients?.data ?? [];
  const totalOnPage = list.length;
  const hasNextPage = totalOnPage >= pageSize;
  const hasPreviousPage = currentPage > 1;
  const pageSizeSelectedIndex = PAGE_SIZE_OPTIONS.findIndex((o) => o.value === pageSize);

  const getClients = async () => {
    setLoading(true);
    let result = {};

    const offset = (currentPage - 1) * pageSize;
    const nameParam = filters?.name?.trim();
    const emailParam = filters?.email?.trim();
    const cpfParam = filters?.documentNumber?.replace(/\.|-/g, "")?.trim();

    try {
      const queryParams = {
        OffSet: offset,
        Fetch: pageSize,
      };
      if (nameParam) queryParams.Nome = nameParam;
      if (emailParam) queryParams.Email = emailParam;
      if (cpfParam) queryParams.Cpf = cpfParam;

      const queryString = qs.stringify(queryParams);
      const url = `api/v1/dashboard/clientes?${queryString}`;

      const apiResponse = await api.get(url, {
        qs: queryString,
        ...withAuthHeader(),
      });

      const data = mapFetchClientsListResponse(apiResponse.data);
      result = { success: true, data };
    } catch (e) {
      result = { error: e.message };
    }
    setClients(result);
    setLoading(false);
  };

  useEffect(() => {
    getClients();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, currentPage, pageSize]);

  return (
    <Wrapper>
      <ClientsFilter onFilter={handleFilter} totalClients={totalOnPage} />
      <ClientsTable
        clients={list}
        hasFilter={!!filters}
        loading={loading}
      />
      <Box mb="50px">
        {!loading && (
          <ClientFooter>
            <FooterText>N° de clientes nesta página: {totalOnPage}</FooterText>
            <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
              <SelectWrapper>
                <SelectInput
                  options={PAGE_SIZE_OPTIONS}
                  selected={pageSizeSelectedIndex >= 0 ? pageSizeSelectedIndex : 1}
                  onSelect={handlePageSizeChange}
                />
              </SelectWrapper>
              <PaginationButton
                type="button"
                disabled={!hasPreviousPage}
                onClick={() => setCurrentPage((p) => p - 1)}
              >
                Anterior
              </PaginationButton>
              <PaginationInfo>Página {currentPage}</PaginationInfo>
              <PaginationButton
                type="button"
                disabled={!hasNextPage}
                onClick={() => setCurrentPage((p) => p + 1)}
              >
                Próxima
              </PaginationButton>
            </Box>
          </ClientFooter>
        )}
      </Box>
    </Wrapper>
  );
};

export default ClientsPage;
